/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Security32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801A5.452 5.452 0 0031.2 28.93c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 11v2h-1a2 2 0 00-2 2v8a2 2 0 002 2h10a2 2 0 002-2v-8a2 2 0 00-2-2h-1v-2a4 4 0 00-8 0zm6 2v-2a2 2 0 10-4 0v2h4z"
            fill="#fff"
        />
        <path
            d="M15.436 22a.63.63 0 00.566-.301l2.867-4.637a.907.907 0 00.1-.22.735.735 0 00.031-.204.632.632 0 00-.175-.456.585.585 0 00-.44-.182.57.57 0 00-.301.075.742.742 0 00-.236.261l-2.422 4.076-1.34-1.174a.577.577 0 00-.474-.238.58.58 0 00-.438.182.64.64 0 00-.174.46c0 .081.013.159.04.232a.793.793 0 00.14.234l1.713 1.626a.671.671 0 00.543.266z"
            fill={vars.bdlDarkBlue}
        />
    </AccessibleSVG>
);

export default Security32;
